var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0410156,
    y: 0.16626,
    width: 91.6677,
    height: 91.6677,
    rx: 26.9999,
    fill: "url(#paint0_radial_804_8711)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0410156,
    y: 0.16626,
    width: 91.6677,
    height: 91.6677,
    rx: 26.9999,
    fill: "url(#paint1_radial_804_8711)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0410156,
    y: 0.16626,
    width: 91.6677,
    height: 91.6677,
    rx: 26.9999,
    fill: "url(#paint2_radial_804_8711)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.7921 27.9938C68.7921 30.7059 66.5935 32.9046 63.8813 32.9046C61.1692 32.9046 58.9706 30.7059 58.9706 27.9938C58.9706 25.2816 61.1692 23.083 63.8813 23.083C66.5935 23.083 68.7921 25.2816 68.7921 27.9938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8752 62.3692C54.9157 62.3692 62.2444 55.0404 62.2444 45.9999C62.2444 36.9595 54.9157 29.6307 45.8752 29.6307C36.8347 29.6307 29.506 36.9595 29.506 45.9999C29.506 55.0404 36.8347 62.3692 45.8752 62.3692ZM45.8752 55.8215C51.2995 55.8215 55.6967 51.4242 55.6967 45.9999C55.6967 40.5757 51.2995 36.1784 45.8752 36.1784C40.4509 36.1784 36.0536 40.5757 36.0536 45.9999C36.0536 51.4242 40.4509 55.8215 45.8752 55.8215Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1367 44.6904C13.1367 33.6892 13.1367 28.1887 15.2777 23.9868C17.1609 20.2907 20.1659 17.2857 23.862 15.4024C28.0639 13.2615 33.5645 13.2615 44.5657 13.2615H47.1847C58.1859 13.2615 63.6865 13.2615 67.8884 15.4024C71.5844 17.2857 74.5894 20.2907 76.4727 23.9868C78.6137 28.1887 78.6137 33.6892 78.6137 44.6904V47.3095C78.6137 58.3106 78.6137 63.8112 76.4727 68.0131C74.5894 71.7092 71.5844 74.7142 67.8884 76.5974C63.6865 78.7384 58.1859 78.7384 47.1847 78.7384H44.5657C33.5645 78.7384 28.0639 78.7384 23.862 76.5974C20.1659 74.7142 17.1609 71.7092 15.2777 68.0131C13.1367 63.8112 13.1367 58.3106 13.1367 47.3095V44.6904ZM44.5657 19.8092H47.1847C52.7934 19.8092 56.606 19.8143 59.5531 20.055C62.4237 20.2896 63.8917 20.7147 64.9158 21.2365C67.3798 22.492 69.3832 24.4953 70.6387 26.9594C71.1604 27.9834 71.5855 29.4515 71.8201 32.3221C72.0609 35.2691 72.066 39.0818 72.066 44.6904V47.3095C72.066 52.9181 72.0609 56.7308 71.8201 59.6778C71.5855 62.5484 71.1604 64.0165 70.6387 65.0405C69.3832 67.5046 67.3798 69.5079 64.9158 70.7634C63.8917 71.2852 62.4237 71.7103 59.5531 71.9448C56.606 72.1856 52.7934 72.1907 47.1847 72.1907H44.5657C38.957 72.1907 35.1444 72.1856 32.1973 71.9448C29.3267 71.7103 27.8587 71.2852 26.8346 70.7634C24.3706 69.5079 22.3672 67.5046 21.1117 65.0405C20.5899 64.0165 20.1648 62.5484 19.9303 59.6778C19.6895 56.7308 19.6844 52.9181 19.6844 47.3095V44.6904C19.6844 39.0818 19.6895 35.2691 19.9303 32.3221C20.1648 29.4515 20.5899 27.9834 21.1117 26.9594C22.3672 24.4953 24.3706 22.492 26.8346 21.2365C27.8587 20.7147 29.3267 20.2896 32.1973 20.055C35.1444 19.8143 38.957 19.8092 44.5657 19.8092Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_804_8711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7795 68.9171) rotate(-55.3758) scale(83.5473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_804_8711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5056 95.1078) rotate(-65.1363) scale(73.9701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_804_8711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.86975 3.44011) rotate(-8.1301) scale(127.323 27.233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBig);
export default __webpack_public_path__ + "static/media/InstagramBig.3ab281f7469fc660dab4a478b685b8cc.svg";
export { ForwardRef as ReactComponent };